import './PageHeader.scss';

export { default } from './PageHeader';
